//NameSpace Declaration 

window.NHS = window.NHS || {};
if ("undefined" === typeof NHS || null === NHS) {
    NHS = {};
}

if ("undefined" === typeof NHS.Scripts || null === NHS.Scripts) {
    NHS.Scripts = {};
} 

if ("undefined" === typeof NHS.Scripts.Helper || null === NHS.Scripts.Helper) {
    NHS.Scripts.Helper = {};
} 

if ("undefined" === typeof NHS.Scripts.Helper.JSON || null === NHS.Scripts.Helper.JSON) {
    NHS.Scripts.Helper.JSON = {};
} 

if ("undefined" === typeof NHS.Scripts.Globals || null === NHS.Scripts.Globals) {
    NHS.Scripts.Globals = {};
} 

if ("undefined" === typeof NHS.Scripts.CommunityResults || null === NHS.Scripts.CommunityResults) {
    NHS.Scripts.CommunityResults = {};
} 

if ("undefined" === typeof NHS.Scripts.CommunityDetail || null === NHS.Scripts.CommunityDetail) {
    NHS.Scripts.CommunityDetail = {};
} 

if ("undefined" === typeof NHS.Scripts.HomeDetail || null === NHS.Scripts.HomeDetail) {
    NHS.Scripts.HomeDetail = {};
} 

if ("undefined" === typeof NHS.Scripts.PropertyMap || null === NHS.Scripts.PropertyMap) {
    NHS.Scripts.PropertyMap = {};
}

if ("undefined" === typeof NHS.Scripts.MediaPlayer || null === NHS.Scripts.MediaPlayer) {
  NHS.Scripts.MediaPlayer = {};
}

var tempNum;
var fromP;
//Renaming the $ function
var $jq = jQuery.noConflict();

jQuery(document).ready(function () {
    if (jQuery.isFunction(NHS.Scripts.Helper.initMegaMenu)) {
        NHS.Scripts.Helper.initMegaMenu();
    }
});

NHS.Scripts.Helper.initMegaMenu = function () {
    ReferModuleHandler.SetRefer();

    var input = document.querySelector('[data-component="search-autocomplete"]');

    function attachSearchEvents() {
        var url = document.getElementById("typeaheadComponentJs").value;
      NHS.loadJs(url, "", function () {

        const form = document.getElementById("nhs_megaMenuSearchForm");

        if(form)
            var search = new SearchFormComponent({
                form: form,
                shouldAlwaysSubmitForm: true,
                submitButton: document.querySelector("[data-search-submit-megamenu]"),
              useAutocompleteForSubmit: true,
              validationError: document.querySelector("#nhs_field_validation_error")
            });

            var cssInput = document.getElementById("typeAheadCss");
            if(cssInput){
                NHS.loadCss(cssInput.value);
            }
        });
        input.removeEventListener("mouseover", attachSearchEvents);
    }

    if (input) {
        input.addEventListener("mouseover", attachSearchEvents);
    }

}

// Cookies Write Function
NHS.Scripts.Helper.createCookie = function (name, value, days) {
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        var expires = "; expires=" + date.toGMTString();
    }
    else {
        var expires = "";
    }

    document.cookie = name + "=" + value + expires + "; path=/; domain=newhomesource.com";
};

// Cookies Read Function
NHS.Scripts.Helper.readCookie = function (name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(";");
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == " ") c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
};

// Cookies Erase Function
NHS.Scripts.Helper.eraseCookie = function (name) {
    NHS.Scripts.Helper.createCookie(name, "", -1);
};

NHS.Scripts.Helper.stopBubble = function (e) {
    if (!e) var e = window.event;
    e.cancelBubble = true;
    if (e.stopPropagation) e.stopPropagation();
};

function reload(url) {
    window.location.href = url;
}

//This code just check for the refer after a # in the url, if is pass by QueryString or post the controller handle that
var ReferModuleHandler = (function ($) {
    /// the $ is just to handle a common way for jQuery, under this scope
    "use strict";
    var my = {}; // This is our internal object where we define the  

    ///Private Properties    
    var finalUrl = "/common/setrefer";
    ///END Private Properties

    ///Private Methods
    function getHashTagRefer() {
        var parameterName = "refer";
        var exp = "[#|&]" + parameterName + "=" + "([^&]+)(&|$)";
        var val = (RegExp(exp).exec(decodeURIComponent(location.hash)) || [, null])[1];

        if (val === null || val === "null") {
          val = "";
        }

        return val;
    }

    function setReferTag() {
        var refVal = getHashTagRefer();
        var refUrl = "";

        if (refVal != null && refVal != "") {
            if (typeof (document.referrer) != "undefined" && document.referrer != "") {
                refUrl = document.referrer;
            }

            $.ajax({
                type: "GET",
                url: finalUrl,
                data: { refVal: refVal, refUrl: refUrl }
            }).done(function (data) {
                //...do something here if is required                
            });
        }
    }
    ///END Private Methods


    ///Public Methods
    my.SetRefer = function () {
        setReferTag();
    };
    ///END Public Methods

    return my; //return the object when you define your public logic
}(jQuery));